import React, { useState, useCallback } from "react";
import { useFormik } from "formik";
import CustomSelect from "./CustomSelect/CustomSelect.component";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function SearchFilter(props) {

  // Redux state 
  const token = useSelector(state => state.auth.token);
  const userData = useSelector(state => state.auth.data);
  const services = useSelector(state => state.services.services);

  const getAllPosts = useCallback(async (values) => {
    let url = "";
    values ? 
      url = `${process.env.REACT_APP_BASE_URL}/api/posts?service_id=${values.category}&post_title=${values.searchText}&latitude=${userData?.latitude}&longitude=${userData?.longitude}&near_by_radius=100` 
      : url = `${process.env.REACT_APP_BASE_URL}/api/posts?latitude=${userData?.latitude}&longitude=${userData?.longitude}&near_by_radius=100`;

    await fetch(url, {
      method: "GET", 
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    .then(r => r.json())
    .then(response => {
      if(response.success && response.records.data.length > 0){
        let filteredData = response.records.data.filter(items => items.status !== 3 );
        if(filteredData.length > 0 ){
          props.setPosts(filteredData);
        } else {
          props.setFlag({type: "error", message: "Posts not found against your query."})
        }

      } else {
        props.setPosts("");
        props.setFlag({type: "error", message: response.message})
      }
    })
  });


  const formik = useFormik({
    initialValues: {
      searchText: "",
      category: ''
    },
    onSubmit: async (values) => {
      getAllPosts(values);
    },
  });

  const resetFilter = (e) => {
    e.preventDefault();
    formik.resetForm();
    getAllPosts();
  }

  // const getLatlong = (e) => {
  //   e.preventDefault();
  //   navigator.geolocation.getCurrentPosition(function(position) {
  //     console.log("Latitude is :", position.coords.latitude);
  //     console.log("Longitude is :", position.coords.longitude);
  //     setLatLong({
  //       lat: position.coords.latitude,
  //       lng: position.coords.longitude
  //     });
  //   });
  // }


  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <aside
          className={`bds-searchfilter ${props.toggleFilter ? "translate-x-end" : ""
            }`}
        >
          <button
            type="button"
            className="bds-closefilter"
            onClick={() => props.setToggleFilter(false)}
          >
            <i className="icon-x"></i>
          </button>
          <div className="bds-searchfilter-wrap">
            <div className="bds-aside-holder">
              <div
                className="bds-asidetitle"
                data-bs-toggle="collapse"
                data-bs-target="#side1"
                role="button"
              >
                <h5>Search</h5>
              </div>
              <div id="side1" className="collapse show">
                <div className="bds-aside-content">
                  <div className="bds-inputiconbtn">
                    <div className="bds-placeholderholder">
                      <input
                        type="text"
                        name="searchText"
                        className="form-control bds-themeinput"
                        placeholder="Search with keyword"
                        onChange={formik.handleChange}
                        value={formik.values.searchText}
                      />
                    </div>
                    {/* <Link to="#">
                      <a className="bds-search-icon">
                        <i className="icon-search"></i>
                      </a>
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="bds-aside-holder">
              <div
                className="bds-asidetitle"
                data-bs-toggle="collapse"
                data-bs-target="#side2"
                role="button"
              >
                <h5>Categories</h5>
              </div>
              <div id="side2" className="collapse show">
                <div className="bds-aside-content">
                  <div className="bds-filterselect">
                    <ul className="bds-categoriesfilter">
                      {
                        services && services.map((item, idx) =>
                          <li key={idx}>
                            <div className="bds-form-checkbox">
                              <label className="form-check-label d-flex align-items-center overflow-hidden" htmlFor={`bds-check-${idx}`}>
                                <input
                                  id={`bds-check-${idx}`}
                                  className="form-check-input bds-form-check-input-sm me-2"
                                  type="checkbox"
                                  name="category"
                                  value={item?.id}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <span>{item?.service_name}</span>
                              </label>
                            </div>
                          </li>
                        )
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>
           {/* <div className="bds-aside-holder">
              <div
                className="bds-asidetitle"
                data-bs-toggle="collapse"
                data-bs-target="#side3"
                role="button"
              >
                <h5>Search Nearby</h5>
              </div>
               <div id="side3" className="collapse show">
                <div className="bds-aside-content">
                  <div className="bds-inputiconbtn">
                    <button type="button" className="bds-btn-solid w-100 theme-rounded" onClick={e => getLatlong(e)}>Get Location</button>
                    <div className="bds-placeholderholder my-2 ">                      
                      {
                        Object.keys(latlong).length > 0 && 
                        <input
                          type="text"
                          name="radius"
                          className="form-control bds-themeinput"
                          placeholder="e.g, 100 (values in meter)"
                          onChange={formik.handleChange}
                          value={formik.values.radius}
                        />
                      }
                    </div>                    
                  </div>
                </div>
              </div> 
            </div>*/}
            {/* <div className="bds-aside-holder">
              <div
                className="bds-asidetitle"
                data-bs-toggle="collapse"
                data-bs-target="#side3"
                role="button"
              >
                <h5>Price range</h5>
              </div>
              <div id="side3" className="collapse show">
                <div className="bds-aside-content">
                  <div
                    className="bds-rangevalue"
                    data-bs-target="#rangecollapse"
                    role="list"
                  >
                    <div className="bds-areasizebox">
                      <input
                        type="number"
                        className="form-control theme-rounded"
                        min="0"
                        placeholder="Min price"
                        name="minPrice"
                        value={formik.values.minPrice}
                        handleBlur={formik.handleBlur}
                        handleChange={formik.handleChange}
                      />
                      <input
                        type="number"
                        className="form-control theme-rounded"
                        step="1"
                        placeholder="Max price"
                        name="maxPrice"
                        value={formik.values.maxPrice}
                        handleBlur={formik.handleBlur}
                        handleChange={formik.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="bds-filterbtns">
              <button type="submit" className="bds-btn-solid-lg w-100">
                Apply filters
              </button>
              <button
                type="reset"
                onClick={(e) => resetFilter(e)}
                className="bds-btn-solid bds-btn-plain w-100"
              >
                Clear all filters
              </button>
            </div>
          </div>
        </aside>
      </form>
    </>
  );
}
